import * as React from 'react';
const Spinner = (props) => {
    const { className, text } = props;
    const BEM = () => {
        const classArray = ['spinner'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (React.createElement("span", { className: BEM() },
        React.createElement("svg", { className: "spinner__circle", viewBox: "25 25 50 50", focusable: "false" },
            React.createElement("circle", { className: "spinner__path", cx: "50", cy: "50", r: "22", fill: "none" })),
        text && React.createElement("span", { className: "spinner__text" }, text)));
};
export { Spinner as default, };
